import { render, staticRenderFns } from "./XTableCount.vue?vue&type=template&id=3529c59d"
import script from "./XTableCount.vue?vue&type=script&lang=js"
export * from "./XTableCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports